let lockCount = 0;

export function lockScroll() {
  lockCount += 1;
  if (lockCount > 1) return;

  document.documentElement.style.overflow = "hidden";
  document.body.style.overflow = "hidden";
}

export function unlockScroll() {
  lockCount -= 1;
  if (lockCount > 0) return;

  lockCount = 0;

  document.documentElement.style.overflow = "";
  document.body.style.overflow = "";
}
